module.exports = function() {
	return new Worker(__webpack_public_path__ + "worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader!./src/tg/Session/SessionWorker.ts
// module id = 558
// module chunks = 0